import apiClient from './api'; // Import the configured axios instance you provided

// Profile related API services
export const employeeService = {
  /**
   * Get employee profile data
   * @returns {Promise} with employee data
   */
  getEmployeeProfile: async () => {
    try {
      const response = await apiClient.get('/regdetail');
      // Handle possible array response or direct object response
      return Array.isArray(response.data) ? response.data[0] : response.data;
    } catch (error) {
      throw error;
    }
  },
  
  /**
   * Update employee profile information
   * @param {Object} employeeData - Data to update (emp_id, contact_num, alter_contact, address)
   * @returns {Promise} with update result
   */
  updateEmployeeProfile: async (employeeData) => {
    try {
      const response = await apiClient.put('/regdetail/update', employeeData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  
  /**
   * Change employee password
   * @param {Object} passwordData - Contains emp_id, oldPassword, newPassword
   * @returns {Promise} with password change result
   */
  changePassword: async (passwordData) => {
    try {
      const response = await apiClient.post('/changepassword', passwordData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};